<template>
  <div id="user-data">
    <div class="vx-row" id="page-user-view">
    </div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
            <div style="display: flex;  align-items: stretch; width: 600px;" class="mt-4">
              <!-- Bouton "Copy Table" -->
              <div style="margin-bottom: 10px;">
                <vs-button v-if="displayExport != false" style="width: 200px; font-weight: bold;"
                  @click="copyToClipboard('thistable')">
                  Copy Table
                </vs-button>
              </div>

              <!-- Bouton "Previous Month" -->
              <div style="margin-top: 8px; width: 200px; text-align: center; cursor: pointer; font-weight: bold;"
                @click="nextMonth(-1)">
                &laquo; Previous Month
              </div>

              <!-- Bouton "Next Month" -->
              <div style="margin-top: 8px; width: 200px; text-align: center; cursor: pointer; font-weight: bold;"
                @click="nextMonth(1)">
                Next Month &raquo;
              </div>
            </div>
          <template>
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row"></div>
              <template>
                <div>
                  <vs-table id="select_txt" ref="table" :data="usages" search>
                    <div slot="header" class="
                        flex flex-wrap-reverse
                        items-center
                        flex-grow
                        justify-between
                      ">
                      <div class="
                          flex flex-wrap-reverse
                          items-center
                          data-list-btn-container
                        "></div>
                    </div>

                    <template slot="thead">
                      <vs-th>Employee</vs-th>
                      <vs-th>Gloves (units)</vs-th>
                      <vs-th>Earplugs (units)</vs-th>
                      <vs-th>Glasses (units)</vs-th>
                      <vs-th>Headphones (units)</vs-th>
                      <vs-th>Jacket (units)</vs-th>
                      <vs-th>Shoes (units)</vs-th>
                      <vs-th>Tape Measures (units)</vs-th>
                      <vs-th>Trousers (units)</vs-th>
                      <vs-th>Wrench (units)</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                            <p>
                              <b>{{ tr.company_name }}</b>
                            </p>
                          </vs-td>
                          <vs-td>{{ tr.Gloves }}</vs-td>
                          <vs-td>{{ tr.Earplugs }}</vs-td>
                          <vs-td>{{ tr.Glasses }}</vs-td>
                          <vs-td>{{ tr.Headphones }}</vs-td>
                          <vs-td>{{ tr.Jacket }}</vs-td>
                          <vs-td>{{ tr.Shoes }}</vs-td>
                          <vs-td>{{ tr.TapeMeasures }}</vs-td>
                          <vs-td>{{ tr.Trousers }}</vs-td>
                          <vs-td>{{ tr.Wrench }}</vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table><br />
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "@/axios.js";
import Datepicker from "vuejs-datepicker";
import moduleEmployeeList from "@/store/employee/moduleDataList.js";
import moment from "moment";
import momentbusiness from "moment-business-days";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      buttonSubmitOpen: false,
      state: {},
      workingHours: 0,
      workingDays: 0,
      monthInTop: 0,
      yearInTop: 0,
    };
  },
  computed: {
    usages() {
      return this.$store.state.dataListEmployee.usages;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.attendance_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.attendance_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {

    nextMonth(value) {
      if (value == -1) {
        if (this.$route.params.month == 1)
          window.location.replace(
            "/web/employees/usages/" +
              (this.$route.params.year - 1) +
              "/12"
          );
        else
          window.location.replace(
            "/web/employees/usages/" +
              this.$route.params.year +
              "/" +
              (this.$route.params.month - 1)
          );
      } else {
        if (this.$route.params.month == 12)
          window.location.replace(
            "/web/employees/usages/" +
              (parseInt(this.$route.params.year) + 1) +
              "/01"
          );
        else
          window.location.replace(
            "/web/employees/usages/" +
              this.$route.params.year +
              "/" +
              (parseInt(this.$route.params.month) + 1)
          );
      }
    },
    ViewEmployee(id) {
      window.location.replace("/web/employees/report/" + id);
    },
    copyToClipboard(containerid) {
      var range = document.createRange();
      let containerNode = document.getElementById(containerid); //// this part
      range.selectNode(containerNode); //// this part
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
    },
    padLeadingZeros(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    tranformDate(dt) {
      const format1 = "YYYY-MM-DD HH:mm:ss";
      return moment(dt).format(format1);
    },
    fetchUsages(year, month) {
      this.$store.dispatch("dataListEmployee/fetchUsages", {
        year,
        month,
      });
    },
  },

  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    if (!moduleEmployeeList.isRegistered) {
      this.$store.registerModule("dataListEmployee", moduleEmployeeList);
      moduleEmployeeList.isRegistered = true;
    }    
    this.monthInTop = this.$route.params.month;
    this.yearInTop = this.$route.params.year;
    this.fetchUsages(this.yearInTop, this.monthInTop);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
